/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';
import { Form } from 'react-bootstrap';

export const FormLabel = styled(Form.Label)`
  font-size: 14px;
  // padding-left: 1rem;
  // position:fixed;
  // position : auto;
  padding-top: 2%;
  color: ${(props) => props?.color ?? '#000000'};
  font-weight: 600;
`;

export const FeedbackLabel = styled(Form.Control.Feedback)`
  // padding-left: 1rem;
  // padding-bottom: 1rem;
  // position: absolute;
  // top: 1.6rem;
  // left: 2%;
  // width: 40vw;
  // border:1px solid blue;
`;

export const FeedbackOtherLabel = styled(FeedbackLabel)`
  color: red;
  font-size: 0.875em;
`;
